import { createSlice } from '@reduxjs/toolkit';

import { initFinished, initSucceeded } from '../../actions/cabinListActions';

const initialState = {
  initialized: false,
};

// `cabinSelected` is the only action here that no thunk dispatches, so it is the only one that can
// be slice-generated without an import cycle with the actions module.
const cruiseSlice = createSlice({
  name: 'cruise',
  initialState,
  reducers: {
    cabinSelected: (state, action) => {
      state.selectedCabinKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(initFinished, (state) => {
        state.initialized = true;
      })
      // Returns a new object because the cruise payload is spread over the slice wholesale.
      .addCase(initSucceeded, (state, action) => ({
        ...state,
        ...action.payload.cruise,
        totalDuration: action.payload.totalDuration,
        priceDetails: action.payload.priceDetails,
      }));
  },
});

export const { cabinSelected } = cruiseSlice.actions;

export default cruiseSlice.reducer;
